import { ReactComponent as SettingIcon } from '../../Assets/Icons/settingIcons.svg';
import { ReactComponent as AgenciesIcon } from '../../Assets/Icons/agenciesIcon.svg';
import { ReactComponent as QuotesIcon } from '../../Assets/Icons/QuoteIcon.svg';
import { ReactComponent as InsightsIcon } from '../../Assets/Icons/InsightIcon.svg';
import { ReactComponent as EscalatedIcon } from '../../Assets/Icons/EscalatedIcon.svg';
import { ReactComponent as OversightIcon } from '../../Assets/Icons/brainIcon.svg';
import { ReactComponent as AgentIcon } from '../../Assets/Icons/agentIcon.svg';

export const getSidebarOptionList = [
    {
        itemName: "Agents",
        componentName: "agents",
        icon: AgentIcon,
        flagAllow: true,
        subMenu: []
    },
    {
        itemName: "Agencies",
        componentName: "agencies",
        icon: AgenciesIcon,
        flagAllow: true,
        subMenu: []
    },
    {
        itemName: "Insights",
        componentName: "insights",
        icon: InsightsIcon,
        flagAllow: true,
        subMenu: []
    },
    {
        itemName: "Escalated",
        componentName: "escalated",
        icon: EscalatedIcon,
        flagAllow: true,
        subMenu: []
    },
    {
        itemName: "Quotes",
        componentName: "quotes",
        icon: QuotesIcon,
        flagAllow: false,
        subMenu: []
    },
    {
        itemName: "3PS Codes",
        componentName: "threepscodes",
        icon: QuotesIcon,
        flagAllow: true,
        subMenu: []
    },
    {
        itemName: "Settings",
        componentName: "settings",
        icon: SettingIcon,
        flagAllow: false,
        subMenu: [
            {
                itemName: "LNID",
                componentName: "LNID",
                icon: SettingIcon,
                flagAllow: false,
                subMenu: []
            },
            {
                itemName: "3PS",
                componentName: "3PS",
                icon: SettingIcon,
                flagAllow: false,
                subMenu: []
            }
        ]
    },
    {
        itemName: "Oversight",
        componentName: "oversight",
        icon: OversightIcon,
        flagAllow: true,
        subMenu: [],
        externalLink: "https://instabrain-brainsights.web.app/"
    }
];
